import { createContext, useContext } from 'react';

interface LoaderContextValue {
  startNavigationLoading: () => void;
  stopNavigationLoading: () => void;
}

export const LoaderContext = createContext<LoaderContextValue>({
  startNavigationLoading: () => {},
  stopNavigationLoading: () => {},
});

export function useLoader() {
  return useContext(LoaderContext);
}
